
import Vue from "vue";
import { Component } from "vue-property-decorator";
import IconButton from "@/components/UI/IconButton.vue";

@Component({
  components: {
    IconButton
  }
})
export default class IconButtonShuffle extends Vue {
  isRotating = false;

  handleClick(event: MouseEvent) {
    this.isRotating = true;
    this.$emit("update", event);
    setTimeout(() => {
      this.isRotating = false;
    }, 600);
  }
}
